import { ImageSetModel } from '@/store/models/Image';

/**
 * Czy zestaw grafik jest KOMPLETNY (wszystkie trzy gęstości).
 *
 * Pusty string liczy się jak brak: kafel bez materiałów (np. Shoulder Disarticulation do
 * czasu GLA-66) ma pokazać swoją nazwę, a nie pustą ramkę po obrazie. Wcześniej warunek
 * sprawdzał tylko `!= null`, więc `''` przechodziło jako „obraz jest".
 */
export function hasCompleteImageSet(set?: ImageSetModel | null): boolean {
	return !!set && !!set.image_1x && !!set.image_2x && !!set.image_3x;
}

/**
 * Czy jest cokolwiek do wyświetlenia — dla pojedynczego zestawu albo dla listy zestawów.
 *
 * PUSTA TABLICA ZNACZY BRAK. `[].every(...)` jest prawdziwe próżniowo, więc warunek oparty
 * na samym `every` uznawał `image_uri: []` za „obraz jest" i render leciał na `images[0]`,
 * czyli `undefined` → TypeError. A `[]` zwraca i mój endpoint montażu, i `ProsthesisResource`
 * dla produktu bez grafik (znalazła Rita, GLA-75 r1).
 */
export function hasUsableImages(
	images?: ImageSetModel | ImageSetModel[] | null,
): boolean {
	if (Array.isArray(images)) {
		return images.length > 0 && images.every(hasCompleteImageSet);
	}

	return hasCompleteImageSet(images);
}
